import React, { PropTypes } from 'react';

export default class Image extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: true
		};
	}

	imageLoaded() {
		this.setState({loading: false});
	}

	renderCaption() {
		const { caption } = this.props;
		return caption 
			? <div className="image-caption">{caption}</div>
			: null;
	}

	onClickEvent() {
		const { onClick } = this.props;
		if (onClick) onClick();
	}

	render() {
		const { loading } = this.state;
		const { src, height } = this.props;

		return (
			<div 
				className={`image-with-loader ${loading?'loading':'loaded'}`} 
				onClick={() => this.onClickEvent()}
			>
				<div className="image">
					<img 
						src={src}
						height={height}
						onLoad={() => this.imageLoaded()}
						onLoadStart={() => console.warn("Opa, loadstart!")}
						onLoadedMetadata={() => console.warn("Opa, loadend!")}
					/>
					{this.renderCaption()}
				</div>

				<div className='loader'>
					<i className='fas fa-spinner fa-pulse fa-lg' />
				</div>
			</div>
		);
	}
}

Image.propTypes = {
	src: PropTypes.string.isRequired,
	caption: PropTypes.string,
	onClick: PropTypes.func,
	height: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/Common/Image.js